import InputMask from './InputMask'
export default InputMask
